import Spinner from "@/components/Spinner";
import { useState } from "react";
import { endpoints } from "../../../hooks/endpoints";
import { getToken } from "../../../hooks/utils";
import { useAppDispatch } from "../../../store/hooks";
import { invokeUserRefetch } from "../../../store/slices/storeSlice";
import Animation from "../../Animation";
import { LessonDataI, LiveSessionDataI } from "../../quiz/typesAndEnums";

const FreePurchase = ({
  lessonData,
}: {
  lessonData: LessonDataI | LiveSessionDataI;
}) => {
  const [isPending, setIsPending] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const dispatch = useAppDispatch();

  const handleFreePurchase = (lesson_id: number) => {
    setIsPending(true);

    fetch(endpoints.freePurchase + "?lesson=" + lesson_id, {
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result !== "not-free") {
          dispatch(invokeUserRefetch());
        } else {
          setError(result);
        }
        setIsPending(false);
      })
      .catch((err) => {
        console.log(err);
        setError("حدث خطأ");
        setIsPending(false);
      });
  };

  if (isPending) return <Spinner />;

  if (error)
    return (
      <div className="w-full rounded-lg bg-red-100 border border-red-400 text-red-700 px-4 py-3">
        {error}
      </div>
    );

  return (
    <Animation>
      <div className="container flex justify-center items-center w-full">
        <button
          onClick={() => handleFreePurchase(lessonData.lesson_id)}
          className="mx-auto my-3 px-6 py-2 rounded-lg bg-primary text-white font-bold hover:bg-primary/90 transition"
        >
          الإشتراك فالحصة مجاناً
        </button>
      </div>
    </Animation>
  );
};

export default FreePurchase;
